export default __webpack_public_path__ + "static/media/Kladersbyte.4a9b7c10.jpg";